<template>
	<div v-on="$listeners">InstallableBox {{ installable.id }}</div>
</template>

<script>
export default {
	name: 'InstallableBox',
	props: {
		installable: { type: Object },
	},
};
</script>

<style lang="scss" scoped></style>
